exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-email{word-break:break-all;max-width:23em}", ""]);

// exports
